export default "__VITE_ASSET__B$ylU95n__"